var params = {};
params.remedy_start = 2015;
params.app_name_long = "HSC Pension Scheme Partial Retirement Calculator";
params.app_name_short = "calculator";
export default params;
